import styled from 'styled-components';

const FlexHeader = styled.div`
   display: flex;
   justify-content: space-between;
`;

export default FlexHeader;